import store from "@store";
import axios from "axios";

export function dealCancelToken() {
  // 取消请求
  store.state.source && store.state.source.cancel("cancel");
  // 创建新的请求标识
  store.commit("setSource", axios.CancelToken.source());
}
